module.exports = __webpack_public_path__ + "img/7_f.12f1785c.jpg";